import React from "react";
import { scopeColorAt } from "./chartPalette";
import * as S from "./scopeDashboard.styles";

/**
 * Horizontal bar list of the highest-emitting KPIs for a scope, each labelled
 * with its share of the scope total. The dot and bar track the KPI's position
 * in the (contribution-sorted) list, so the colour matches the trend chart.
 * @param {{questionId:number,title:string,value:number,pct:number}[]} props.items
 */
export const TopContributingKpis = ({ items = [] }) => {
  if (!items.length) {
    return <S.Empty>No emissions recorded for this scope.</S.Empty>;
  }

  return (
    <S.TopKpis>
      {items.map((k, i) => {
        const color = scopeColorAt(i);
        return (
          <div key={k.questionId}>
            <S.TopKpiHead>
              <S.TopKpiName title={k.title || ""}>
                <S.Dot $color={color} />
                <span>{k.title || `KPI ${k.questionId}`}</span>
              </S.TopKpiName>
              <S.TopKpiPct>{k.pct}%</S.TopKpiPct>
            </S.TopKpiHead>
            <S.TopKpiTrack>
              <S.TopKpiFill $pct={k.pct} $color={color} />
            </S.TopKpiTrack>
          </div>
        );
      })}
    </S.TopKpis>
  );
};
